import { programAllows } from "utils";

import { CarbonProgram } from "models";

import { getHomeSegment } from "pages/app/home/hero/homeSegment";

export type AgronomistCardId = "soilSight" | "coverCropMixer" | "terra";

type AgronomistCardsInput = {
  carbonProgram: CarbonProgram | null | undefined;
  soilSightEnabled: boolean;
  copilotEnabled: boolean;
};

/** The cards in their order on the page; the first one rendered is the place to start, so product reorders here */
export const AGRONOMIST_CARD_ORDER: AgronomistCardId[] = ["soilSight", "coverCropMixer", "terra"];

export const agronomistCards = ({ carbonProgram, soilSightEnabled, copilotEnabled }: AgronomistCardsInput): AgronomistCardId[] => {
  const available: Record<AgronomistCardId, boolean> = {
    soilSight: soilSightEnabled,
    coverCropMixer: programAllows(carbonProgram, "cropMixComposer"),
    terra: copilotEnabled,
  };
  return AGRONOMIST_CARD_ORDER.filter((card) => available[card]);
};

/**
 * Footprinting-only farms have no digital agronomist, even when their program has planning features, and neither do other programs
 * without planning features; programs that predate the feature settings keep it.
 */
export const programHidesAgronomist = (carbonProgram: CarbonProgram | null | undefined): boolean =>
  getHomeSegment(carbonProgram) === "footprinting-only" || (!!carbonProgram?.platformFeatures && !carbonProgram.platformFeatures.planning);
